export default "__VITE_ASSET__DsOyhJ9A__"